import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { NewsfeedService } from './../_services/newsfeed.service';
import { ConfirmboxComponent } from 'src/app/confirmbox/confirmbox.component';
import { MatDialog, MatDialogRef } from '@angular/material';

@Component({
  selector: 'app-postbox',
  templateUrl: './postbox.component.html',
  styleUrls: ['./postbox.component.scss']
})

export class PostboxComponent implements OnInit {

  @Input('type') type;
  @Input('post') post;
  @Input('user') user;
  @Input('feed_type') feed_type;
  @Input('tourId') tourId = 0;
  @Input('lgId') lgId = 0;
  @Output() close: EventEmitter<Number> = new EventEmitter();
  @ViewChild('postboxVar') postboxVarElement: any;
  @ViewChild('postboxInput') postboxInputElement: any;
  @ViewChild('postpollInput') postpollInputElement: any;
  
  offsetTopHeight = 0;
  headerText = 'Create a Post';
  mode = 'post';
  poll = {
    question: '',
    options: ['', '']
  };
  errorMessage = '';
  errorVisible = false;
  push_notification = true;
  detail = null;
  saving = false;
  gif = null;
  isEmojiPickerVisible: boolean;
  isGifPickerVisible: boolean;
  confirmDialogRef: MatDialogRef<ConfirmboxComponent>;
  userId = null;

  constructor(
    private _newsFeedService: NewsfeedService,
    public dialog: MatDialog
  ) { 
    const currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (currentUser != null) {
      this.userId = currentUser.id;
    }
  }

  ngOnInit() {
    if (this.type == null) this.type = 'post';
    if (this.feed_type == null) this.feed_type = 'status_update';
    if (this.type == 'reply') {
      this.headerText = 'Replying to...';
    }
    
    const rect = this.postboxVarElement.nativeElement.getBoundingClientRect();
    const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const top = rect.top + scrollTop;
    this.offsetTopHeight = (top > 75) ? 40 : 0;
    
    if (this.lgId || this.tourId) {
      this.feed_type = 'league_post';
    }
    
    setTimeout(() => this.postboxInputElement.nativeElement.focus());
  }

  escapeUnicode(str) {
    return str.replace(/[^\0-~]/g, function (ch) {
      return "\\u" + ("000" + ch.charCodeAt().toString(16)).slice(-4);
    });
  }

  deleteOption(index) {
    this.poll.options.splice(index, 1);
  }

  save() {
    this.saving = true;
    if (this.mode == 'post') {
      if (this.gif !== null) {
        if (this.detail) {
          this.detail =  this.detail + ' {GIF' + this.gif + '}';
        }
        else {
          this.detail =  '{GIF' + this.gif + '}';
        }
      }
      if (this.type == 'post') {
        //call post API
        this.makePost();
      } else if (this.type == 'reply') {
        //call comment API
        this.makeComment();
      }
    } else if (this.mode == 'poll') {
      // verify poll data first
      if (this.poll.question != '' && this.poll.question.length <= 200) {
        const removeIndices = [];
        this.poll.options.forEach((option, index) => {
          if (option == '') removeIndices.push(index);
        });
        removeIndices.forEach((index, i) => {
          this.poll.options.splice(index - i, 1);
        });
        if (this.poll.options.length >= 2) {
          this._newsFeedService.createPoll(this.user.id, this.poll.question, this.poll.options).subscribe(state => {
            if (state.status == 'success') {
              const poll_id = state.poll_id;
              this.makePollPost(poll_id);
            } else {
              this.errorMessage = state.message;
              this.showError();
            }
            this.saving = false;
          });
        } else {
          this.saving = false;
          this.errorMessage = 'Not enough valid poll options.';
          this.showError();
        }
      } else {
        this.saving = false;
        this.errorMessage = 'Invalid poll question length.';
        this.showError();
      }
    } else if (this.mode == 'gif') {
      // this.gif holds the url to post
      this.detail = '{GIF' + this.gif + '}';
      if (this.type == 'post') {
        //call post API
        this.makePost();
      } else if (this.type == 'reply') {
        //call comment API
        this.makeComment();
      }
    }
  }

  showError() {
    this.errorVisible = true;
    console.log(this.errorMessage, this.poll);
    setTimeout(() => {
      this.errorVisible = false;
      this.errorMessage = '';
    }, 3000);
  }
  
  changeMode(mode) {
    this.mode = mode;
    if (mode == 'poll') {
      setTimeout(() => this.postpollInputElement.nativeElement.focus());
    }
    else {
      setTimeout(() => this.postboxInputElement.nativeElement.focus());
    }
  }

  emitClose(num = 0) {
    this.close.emit(num);
  }

  makePollPost(poll_id) {
    this._newsFeedService.makePost(this.user.id, '{POLL' + poll_id + '}', this.feed_type, this.user.drafters_id, this.push_notification, this.lgId, this.tourId).subscribe(state => {
      if (state.status == 'success') {
        if(this.userId != 253)
          this.confirmDialogRef = this.dialog.open(ConfirmboxComponent, {
            width: '500px',
            data: { 'title': "New Feed Post", 'body': "Thanks for your post! it's been submitted to Drafters Support for approval.",'type':'alert-box'}
        });
        this.emitClose(1);
      } else {
        this.errorMessage = state.message;
        this.showError();
      }
      this.saving = false;
    });
  }

  makePost() {
    if (this.detail != '') {
      this._newsFeedService.makePost(this.user.id, this.escapeUnicode(this.detail), this.feed_type, this.user.drafters_id, this.push_notification, this.lgId, this.tourId).subscribe(state => {
        if (state.status == 'success') {
          if(this.userId != 253)
            this.confirmDialogRef = this.dialog.open(ConfirmboxComponent, {
              width: '500px',
              data: { 'title': "New Feed Post", 'body': "Thanks for your post! it's been submitted to Drafters Support for approval.",'type':'alert-box'}
          });
          this.emitClose(1);
        } else {
          this.errorMessage = state.message;
          this.showError();
        }
        this.saving = false;
      });
    } else {
      this.errorMessage = 'You can\'t make an empty post.';
      this.showError();
      this.saving = false;
    }
  }

  makeComment() {
    if (this.detail != '') {
      this._newsFeedService.makeComment(this.user.id, this.post.id, this.user.drafters_id, this.escapeUnicode(this.detail)).subscribe(state => {
        if (state.status == 'success') {
          this.emitClose(2);
        } else {
          this.errorMessage = state.message;
          this.showError();
        }
        this.saving = false;
      });
    } else {
      this.errorMessage = 'You can\'t make an empty comment.';
      this.showError();
      this.saving = false;
    }
  }

  trackOptions(index, obj) {
    return index;
  }

  catchGIF(gif) {
    this.gif = gif;
  }
  
  addEmoji(event) {
    this.detail = (this.detail) ? `${this.detail}${event.emoji.native}` : `${event.emoji.native}`;
  }
  
  autoGrowTextZone(e) {
    e.target.style.height = "0px";
    e.target.style.height = (e.target.scrollHeight + 5)+"px";
  }
}
